export const REPRESENTED_ASSETS_CATEGORY = "Represented Assets";
